/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class adjudication extends IceEntity {
  adjudication_key: string = "";
  adjudication_date: any = NaN;
  identification_code: string = "";
  paid_amount: number = 0.0;
  product_service_id_qualifier: string = "";
  code: string = "";
  modifier1: string = "";
  modifier2: string = "";
  modifier3: string = "";
  modifier4: string = "";
  code_description: string = "";
  price: number = 0.0;
  cost: number = 0.0;
  unit_code: string = "";
  quantity: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "ADJUDICATION";
  }
}
